import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './BrokerButton.css';

interface IBrokerButtonProps {
  loading: boolean;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const BrokerButton: React.FC<IBrokerButtonProps> = ({ loading, onClick }) => {
  return (
    <div data-mark="BrokerButton" className={styles['button']}>
      <Button loading={loading} onClick={onClick} size="M" theme="fill_success_primary" type="button" fullWidth>
        Провести сделку
      </Button>
    </div>
  );
};
